var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-lines */
/* eslint-disable max-statements */
import React, { useEffect, useState } from 'react';
import * as extractorsAPI from "../../../../api/paragraphExtractor/extractors";
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import { Modal, Button, MultiselectList } from "../../../../Components/UI";
import { Translate } from "../../../../../I18N";


import { NoQualifiedTemplatesMessage } from "./NoQualifiedTemplate";
import { Link } from 'react-router-dom';









const formatOptions = (templates) =>
templates.map((template) => {
  const option = {
    label: template.name,
    id: template._id,
    searchLabel: template.name,
    value: template._id,
    properties: template.properties
  };
  return option;
});

const templatesWithParagraph = (template) => {var _template$properties;return (_template$properties =
  template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.some(({ name }) => name === 'rich_text');};

const isActiveStepClassName = (isActive) => isActive ? 'bg-indigo-700' : 'bg-gray-200';

const linkPXTemplateCriteria =
'https://uwazi.readthedocs.io/en/latest/admin-docs/paragraph-extraction.html';

const ExtractorModal = ({
  setShowModal,
  onClose,
  onAccept,
  templates,
  extractor
}) => {var _extractor$templateTo;
  const [step, setStep] = useState(1);
  const [templatesFrom, setTemplatesFrom] = useState((extractor === null || extractor === void 0 ? void 0 : extractor.templatesFrom) || []);
  const [templateTo, setTemplateTo] = useState((_extractor$templateTo = extractor === null || extractor === void 0 ? void 0 : extractor.templateTo) !== null && _extractor$templateTo !== void 0 ? _extractor$templateTo : '');

  const [templateToOptions] = useState(formatOptions(templates.filter(templatesWithParagraph)));
  const [templateFromOptions, setTemplateFromOptions] = useState(
    formatOptions(templates.filter((template) => template._id !== templateTo))
  );

  useEffect(() => {
    setTemplateFromOptions(
      formatOptions(templates.filter((template) => template._id !== templateTo))
    );
  }, [templateTo, templates]);

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = async () => {
    try {
      const values = _objectSpread(_objectSpread({},
      extractor), {}, {
        templatesFrom,
        templateTo });

      await extractorsAPI.save(values);
      handleClose();
      onAccept();
    } catch (e) {
      console.error('Error saving extractor:', e);
    }
  };

  return (/*#__PURE__*/
    _jsx(Modal, { size: "xxl" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("h1", { className: "text-xl font-medium text-gray-900" }, void 0,
    extractor ? /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Edit Extractor") :

    step === 1 && /*#__PURE__*/_jsx(Translate, {}, void 0, "Target template") ||
    step === 2 && /*#__PURE__*/_jsx(Translate, {}, void 0, "Paragraph extractor")

    ), /*#__PURE__*/
    _jsx(Modal.CloseButton, { onClick: () => setShowModal(false) })
    ), /*#__PURE__*/

    _jsx(Modal.Body, { className: "pt-0" }, void 0, /*#__PURE__*/
    _jsx("div", { className: `${step !== 1 && 'hidden'}` }, void 0, /*#__PURE__*/
    _jsx(MultiselectList, {
      value: [templateTo],
      items: templateToOptions,
      onChange: (selected) => {
        setTemplateTo(selected[0]);
      },
      singleSelect: true,
      startOnSelected: !!templateTo,
      className: "min-h-[327px]",
      blankState: /*#__PURE__*/_jsx(NoQualifiedTemplatesMessage, {}) }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: `${step !== 2 && 'hidden'}` }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(MultiselectList, {
      value: templatesFrom || [],
      items: templateFromOptions,
      onChange: setTemplatesFrom,
      allowSelelectAll: templateFromOptions.length > 0,
      startOnSelected: templatesFrom.length > 0,
      className: "min-h-[327px]" }
    )
    )
    ), /*#__PURE__*/

    _jsx("div", { className: "flex flex-col" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex justify-center w-full gap-2" }, void 0, /*#__PURE__*/
    _jsx("div", { className: `w-2 h-2 rounded-full ${isActiveStepClassName(step === 1)}` }), /*#__PURE__*/
    _jsx("div", { className: `w-2 h-2 rounded-full ${isActiveStepClassName(step === 2)}` })
    ),
    templateToOptions.length !== 0 && step === 1 && /*#__PURE__*/
    _jsx("span", { className: "mt-5 text-gray-500 font-light text-sm" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Templates meeting required criteria"), ".", ' ', /*#__PURE__*/
    _jsx(Link, { to: linkPXTemplateCriteria, target: "_blank" }, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "underline" }, void 0, "Read Documentation")
    )
    )

    )
    ), /*#__PURE__*/

    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0,
    step === 1 ? /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, { styling: "light", onClick: () => setShowModal(false), className: "grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { className: "grow", onClick: () => setStep(2), disabled: !templateTo }, void 0, /*#__PURE__*/
    _jsx("span", { className: "flex items-center justify-center gap-2 flex-nowrap" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Next"), /*#__PURE__*/
    _jsx(ArrowRightIcon, { className: "w-5" })
    )
    )
    ) : /*#__PURE__*/

    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, { styling: "light", onClick: () => setStep(1), className: "grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Back")
    ), /*#__PURE__*/
    _jsx(Button, { className: "grow", onClick: async () => handleSubmit(), color: "success" }, void 0,
    extractor ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Update") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Add")
    )
    )

    )
    )
    )
    ));

};

export { ExtractorModal, formatOptions };